import {format, subMonths} from 'date-fns';
import {
	GetReferralsParams,
	ReferralStatusEnum,
	ReferralTypeEnum,
} from 'domain/usecases/private/my-referrals-flow/get-referrals';
import { MyReferralsTaggingEnum } from 'main/analytics/gaTagsEnum';
import {translations} from 'presentation/translations-new';

const {all, exam, consult, surgery} = translations['pt-br'].commons;
const {finished, rejected} = translations['pt-br'].privateFlow.myReferrals.status;

export const useReferralsHistory = () => {
	const DefaultParams: GetReferralsParams = {
		dtInicio: format(subMonths(new Date(), 3), 'yyyy-MM-dd'),
		dtFim: format(new Date(), 'yyyy-MM-dd'),
		status: `${ReferralStatusEnum.FINISHED},${ReferralStatusEnum.REJECTED}`,
	};
	const Filters = {
		types: [
			{
				label: all,
				category: 'all',
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_TODOS_HISTORICO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: exam,
				category: ReferralTypeEnum.EXAM,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_EXAME_HISTORICO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: surgery,
				category: ReferralTypeEnum.SURGERY,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_CIRURGIA_HISTORICO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: consult,
				category: ReferralTypeEnum.APPOINTMENT,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_TIPO_PROCEDIMENTO_CONSULTA_HISTORICO_MEUS_ENCAMINHAMENTOS,
			},
		],
		status: [
			{
				label: all,
				category: `${ReferralStatusEnum.FINISHED},${ReferralStatusEnum.REJECTED}`,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_TODOS_HISTORICO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: finished,
				category: ReferralStatusEnum.FINISHED,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_CONCLUIDO_MEUS_ENCAMINHAMENTOS,
			},
			{
				label: rejected,
				category: ReferralStatusEnum.REJECTED,
				dataTagId: MyReferralsTaggingEnum.CLICK_FILTRO_STATUS_INDEFERIDO_MEUS_ENCAMINHAMENTOS,
			},
		],
	};

	return {
		DefaultParams,
		Filters,
	};
};
